import { ArrowLeft, SearchX } from "lucide-react";
import { Link } from "react-router-dom";
import { Brand } from "../components/Brand";

export function NotFoundPage() {
  return (
    <main className="not-found">
      <Brand />
      <SearchX />
      <h1>Página não encontrada</h1>
      <p>O endereço pode ter mudado ou não está disponível neste workspace.</p>
      <Link className="button button--primary" to="/">
        <ArrowLeft size={17} /> Voltar ao início
      </Link>
      <p>
        <Link to="/app/projects">Retomar meus projetos</Link> ·{" "}
        <Link to="/help">Consultar ajuda</Link>
      </p>
    </main>
  );
}
